import { Color, CustomSpacing, SectionComponent, theme } from '@genially/public-web-components';

import type { FC } from 'react';
import { ParagraphButton } from 'components/ParagraphButton';
import { ParagraphColumns } from 'components/ParagraphColumns';
import { ParagraphFullhtml } from 'components/ParagraphFullhtml';
import { ParagraphIcon } from 'components/ParagraphIcon';
import { ParagraphMedia } from 'components/ParagraphMedia';
import { ParagraphModal } from 'components/ParagraphModal';
import { ParagraphParagraph } from 'components/ParagraphParagraph';
import { ParagraphPlay } from 'components/ParagraphPlay';
import { ParagraphSearch } from 'components/ParagraphSearch';
import { ParagraphSearchInput } from 'components/ParagraphSearchInput';
import { parseBackground } from 'core/infrastructure/parseBackground';
import { parseLangPath } from 'core/infrastructure/parseLangPath';

export interface BackgroundDTO {
  backgroundType: 'image' | 'video';
  baseColor: {
    color: Color;
  };
  image?: {
    desktop?: ImageSource;
    laptop?: ImageSource;
    tablet?: ImageSource;
    mobile?: ImageSource;
  };
}

interface ImageSource {
  src: string;
}

interface ParagraphSectionProps {
  behaviorSettings?: {
    rowStyle: {
      background: BackgroundDTO;
      spacing: CustomSpacing;
      general: any;
      borders: any;
      hovers?: any;
    };
    layout_paragraphs: { layout: string; config: any };
  };
  children?: any;
  link?: { url: { path: string } };
  animation?: keyof typeof theme.animations;
}
export const ParagraphSection: FC<ParagraphSectionProps> = ({
  behaviorSettings,
  link,
  children,
  animation,
}) => {
  return (
    <SectionComponent
      layout={behaviorSettings?.layout_paragraphs.layout}
      background={parseBackground(behaviorSettings?.rowStyle?.background)}
      customSpacing={behaviorSettings?.rowStyle.spacing}
      borders={behaviorSettings?.rowStyle.borders}
      general={behaviorSettings?.rowStyle.general}
      hovers={behaviorSettings?.rowStyle.hovers}
      link={link ? parseLangPath(link.url.path) : undefined}
      animation={animation}
    >
      {children &&
        children.map((paragraph: any, index: number) => {
          if (paragraph.type === 'ParagraphSection') {
            return <ParagraphSection key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphColumns') {
            return <ParagraphColumns key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphIcon') {
            return <ParagraphIcon key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphParagraph') {
            return <ParagraphParagraph key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphButton') {
            return <ParagraphButton key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphMedia') {
            return <ParagraphMedia key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphModal') {
            return <ParagraphModal key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphPlay') {
            return <ParagraphPlay key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphFullhtml') {
            return <ParagraphFullhtml key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphSearch') {
            return <ParagraphSearch key={index} {...paragraph.content} />;
          }
          if (paragraph.type === 'ParagraphSearchInput') {
            return <ParagraphSearchInput key={index} {...paragraph.content} />;
          }
        })}
    </SectionComponent>
  );
};
